import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "on-demand-report-creation"
    }}>{`On-Demand Report Creation`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Creating reports is a common requirement for many applications and web experiences. Often, the displayed data and content is generated in HTML. However, many users want to download, share, review offline, or modify these reports, but the native format makes this difficult.`}</p>
    <p>{`Adobe Acrobat Services allows developers to:`}</p>
    <ul>
      <li parentName="ul">{`Download an HTML report in a PDF format to share or review offline`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-embed.md"
        }}>{`Adobe PDF Embed API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`A social media marketing agency has a web application that customers access to see results of different campaigns they are running. Results are formatted and displayed on a password protected part of the site. Clients want to download single reports in PDF format, as well as select multiple reports and combine them into a more comprehensive PDF document that they can share with their management team.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <ol>
      <li parentName="ol">{`Campaign results are made available in a variety of formats, such as Excel tables, HTML pages, and PDF documents`}</li>
      <li parentName="ol">{`Clients review the web page and select desired datasets for their report`}</li>
      <li parentName="ol">{`The application uses PDF Create and PDF Combine operations to assemble the report`}</li>
      <li parentName="ol">{`Clients select "Download Report"`}</li>
    </ol>
    <h3 {...{
      "id": "enhancements"
    }}>{`Enhancements`}</h3>
    <p>{`Users may want to add comments to a report, with insights and action steps. To do this, the application would provide a menu option ("View Report") and use Adobe PDF Embed API to display the report directly within the web page. In addition, annotations, including comments and markup, can also be enabled.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      